import { AbTestSplit } from './types'

export const defineTestVariant = () => {
  const AB_TEST_SPLIT = 'AB_TEST_SPLIT'

  // We need to save result in session storage for the cases when user using back button on steps
  const savedTestVariant = sessionStorage.getItem(AB_TEST_SPLIT)
  let testVariant: AbTestSplit

  if (savedTestVariant === AbTestSplit.Control || savedTestVariant === AbTestSplit.Test) {
    testVariant = savedTestVariant
  } else {
    testVariant = Math.random() >= 0.5 ? AbTestSplit.Test : AbTestSplit.Control
  }

  sessionStorage.setItem(AB_TEST_SPLIT, testVariant)

  return testVariant
}
